// SPDX-FileCopyrightText: 2025 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import React, { useContext, useMemo } from 'react';
import { LabelMetaDataContext } from '../LabelMetaDataProvider';
import ProcessTag from 'components/common/ProcessTag';
import { QCResult } from 'components/project/data/filter/filters-defaults';
import styled from 'styled-components';
import { DropdownContent } from '@tls/treact-ui';

const processTagOptions = [
  {
    id: QCResult.Undefined,
    label: 'undefined process',
    icon: <ProcessTag processTag={QCResult.Undefined} size={'24px'} />,
  },
  {
    id: QCResult.Good,
    label: 'good process',
    icon: <ProcessTag processTag={QCResult.Good} size={'24px'} />,
  },
  {
    id: QCResult.Bad,
    label: 'bad process',
    icon: <ProcessTag processTag={QCResult.Bad} size={'24px'} />,
  },
];

type ProcessTagOptions = (typeof processTagOptions)[number];

interface Props {
  disabled?: boolean;
}

export default function ProcessTagPicker({ disabled }: Readonly<Props>) {
  const { qcResult, setQcResult } = useContext(LabelMetaDataContext);

  const selectedOption = useMemo(() => {
    return processTagOptions.find(o => o.id === qcResult) ?? processTagOptions[0];
  }, [qcResult]);

  return (
    <Root>
      <DropdownContent<ProcessTagOptions>
        disabled={disabled}
        iconSelector={o => o.icon}
        onChange={o => {
          setQcResult(o.id);
        }}
        selectedOption={selectedOption}
        options={processTagOptions}
        keySelector={o => o.id}
        labelSelector={o => o.label}
        data-testid='label-footer-process-tag-dropdown'
        dataTestIdSelector={option => `label-footer-process-tag-option-${option.id}`}
      />
    </Root>
  );
}

const Root = styled.div`
  height: '2.5rem';
  width: '12rem';
  span {
    display: none;
  }
  button {
    span {
      display: block;
    }
  }
`;
